import { IMAGE_DIR } from '@/shared/constants/linksApi'
import styles from './VebinarCard.module.scss'
import { trainingFormat } from '@/entities/vebinars/VebinarCard/consts/trainingFormat.js'

export function VebinarCard({ item, clickHandler }) {
    const cuteImage = IMAGE_DIR + item.image

    const date = new Date(item.date)

    const dateFormat = new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })

    const cuteDate = dateFormat.format(date)

    return (
        <div className={styles.itemWrapper} onClick={clickHandler}>
            <div className={styles.itemHeader}>
                <div>{trainingFormat[item.type]}</div>
                <div>{cuteDate}</div>
            </div>
            <div className={styles.itemImage}>
                <img src={cuteImage} alt="seminar image" />
            </div>
            <div className={styles.itemDescription}>
                <div className={styles.itemDecpration}>бесплатный</div>
                <div className={styles.itemText}>{item.text}</div>
            </div>
            <div className={styles.itemFooter}>Записаться</div>
        </div>
    )
}
